import React, { lazy, Suspense, useEffect } from "react";
import { useDispatch } from "react-redux";
import { createBrowserRouter, RouterProvider, Navigate, Outlet } from "react-router";
import { FocusStyleManager } from "@blueprintjs/core";
import ErrorBoundary from "components/ErrorBoundary";
import Fallback from "components/Fallback";
import RoutePaths from "routes/route-paths";
import { recipeScalingInternalRoutes } from "routes";
import { init } from "store/global/global.actions";
import RouteObserver from "../../HOC/RouteObserver";
import { setRouter } from "shared/navigation";
const Home = lazy(() => import("pages/Home"));
const Help = lazy(() => import("pages/HelpCenter"));
const AdminPanel = lazy(() => import("pages/AdminPanel"));
const Unauthorized = lazy(() => import("pages/Unauthorized"));
const PointScaling = lazy(() => import("pages/PointScaling"));
const PSWorkspace = lazy(() => import("pages/PS-Workspace"));
const RecipeScaling = lazy(() => import("pages/RecipeScaling"));
const router = createBrowserRouter([
    {
        path: "/",
        element: (React.createElement(React.Fragment, null,
            React.createElement(RouteObserver, null),
            React.createElement(Outlet, null))),
        children: [
            { path: RoutePaths.Home, element: React.createElement(Home, null) },
            { path: RoutePaths.Help, element: React.createElement(Help, null) },
            { path: RoutePaths.AdminPanel, element: React.createElement(AdminPanel, null) },
            { path: RoutePaths.Unauthorized, element: React.createElement(Unauthorized, null) },
            { path: RoutePaths.PointScalingWorkspaces, element: React.createElement(PointScaling, null) },
            { path: RoutePaths.PointScalingWorkspace, element: React.createElement(PSWorkspace, null) },
            ...recipeScalingInternalRoutes.map(({ path, element }) => ({ path, element })),
            { path: RoutePaths.RecipeScalingLists, element: React.createElement(RecipeScaling, null) },
            { path: RoutePaths.RecipeScaling, element: React.createElement(Navigate, { to: RoutePaths.RecipeScalingWorkspaces }) },
            { path: "*", element: React.createElement(Navigate, { to: RoutePaths.Home }) },
        ],
    },
]);
setRouter(router);
const AppComponent = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(init());
        FocusStyleManager.onlyShowFocusOnTabs();
    }, [dispatch]);
    return (React.createElement(ErrorBoundary, null,
        React.createElement(Suspense, { fallback: React.createElement(Fallback, null) },
            React.createElement(RouterProvider, { router: router }))));
};
export default AppComponent;
